document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector("newsletter-popup");
  if (!popup) return;

  const inputEmail = popup.querySelector("input[type='email']");
  const closeBtn = document.querySelector(".close-news");
  const newsletterForm3 = document.getElementById("newsletter-form-3");
  const newsletterForm1 = document.getElementById("newsletter-form-1");

  function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + ";expires=" + date.toUTCString() + ";path=/";
  }

  // MOSTRA IL POPUP in base a hash o cookie
  if (window.location.hash === '#newsletter-form-3') {
    popup.classList.remove("hidden");
    Shopify.analytics.publish('newsletter_overaly', { 'label': 'view-from-url' });
  } else if (!getCookie("hideNewsletterPopup")) {
    setTimeout(() => {
      popup.classList.remove("hidden");
      Shopify.analytics.publish('newsletter_overaly', { 'label': 'view-delayed' });
    }, 5000);
  }

  // TRACKING
  if (inputEmail) {
    inputEmail.addEventListener("focus", function () {
      Shopify.analytics.publish('newsletter_overaly', { 'label': 'form-focus' });
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      popup.classList.add("hidden");
      Shopify.analytics.publish('newsletter_overaly', { 'label': 'close_x' });
      setCookie("hideNewsletterPopup", "true", 5);
    });
  }

  function handleFormSubmit(form, analytics = false) {
    if (!form) return;

    form.addEventListener("submit", function () {
      setTimeout(() => {
        const hasSuccessMessage = document.querySelector(".cf-verify-email-message");
        const hasErrors = form.querySelector(".form__message-error") || form.querySelector(".form__message");

        if (hasSuccessMessage || hasErrors) {
          popup.classList.remove("hidden");
        } else {
          popup.classList.add("hidden");
          setCookie("hideNewsletterPopup", "true", 5);
          if (analytics) {
            Shopify.analytics.publish('newsletter_overaly', { 'label': 'close_confirmation' });
          }
        }
      }, 300);
    });
  }

  handleFormSubmit(newsletterForm1);
  handleFormSubmit(newsletterForm3, true);
});